import { Grid } from "@mui/material";
import Input from "../../../../../../../../components/Input";
import { VitalFormik } from "../vital-constant";
import { PatientVital } from "../../../../../../../../services";

interface BmiFieldsProps {
  formik: VitalFormik;
  ind: number;
}

const BmiFields = ({ formik, ind }: BmiFieldsProps) => {
  const activeVital =
    ind !== -1 ? formik.values?.patientVitals?.[ind] : undefined;

  const isSelected = activeVital?.selected ?? false;

  const getKey = (k: keyof PatientVital) => `patientVitals.${ind}.${k}`;

  const getError = (key: keyof PatientVital) => {
    const touched = (formik.touched.patientVitals as any)?.[ind]?.[key];
    const error = (formik.errors.patientVitals as any)?.[ind]?.[key];
    return touched && error ? String(error) : undefined;
  };

  return (
    <Grid container gap={2}>
      <Grid xs={1.8}>
        <Input
          required={isSelected}
          error={getError("value")}
          textFieldProps={{
            name: getKey("value"),
            placeholder: "24.9",
            value: activeVital?.value,
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
          }}
        />
      </Grid>
      {/* Future Reference
      <Grid xs={2.6}>
        <FormControlLabel
          control={<Checkbox />}
          label={<Text>Calculate Bmi</Text>}
          labelPlacement="end"
          sx={{ marginLeft: "10px" }}
        />
      </Grid> */}
    </Grid>
  );
};

export default BmiFields;
